// GraphQL query for Crom API
var query =
  " \
  query InterwikiQuery($url: URL!) { \
    page(url: $url) { \
      translations { \
        url \
      } \
      translationOf { \
        url \
        translations { \
          url \
        } \
      } \
    } \
  } \
";

// GraphQL endpoints for Crom API fallback
// Generally used for proxying
var apiList = [
  "https://api.crom.avn.sh/graphql",
  "https://zh.xjo.ch/crom/graphql",
]

/**
 * @typedef CromPage
 * @type {Object}
 * @property {String} url - The URL of this page.
 */

/**
 * @typedef CromOriginalPage
 * @type {Object}
 * @property {String} url - The URL of this page.
 * @property {Array.<CromPage>} translations - URLs for translations of
 * this page.
 */

/**
 * @typedef CromTranslations
 *
 * Crom's response to a translations request.
 *
 * Generally, either `translations` will be an empty array, or
 * `translationOf` will be null.
 *
 * @type {Object}
 * @property {Array.<CromPage>} translations - URLs for translations of
 * this page.
 * @property {?CromOriginalPage} translationOf - The page that the current
 * page is a translation of.
 */

/**
 * Searches for pages whose fullname matches the given string in the given
 * set of Wikidot sites using Crom query.
 *
 * @param {Branch} currentBranch - Configuration for the current branch.
 * @param {Object.<string, Branch>} branches - The branches configuration
 * for the current community. All passed branches will be searched for the
 * target page.
 * @param {String} fullname - The fullname of the target page.
 * @param {addLinkCallback} addLink - A function that will be called for
 * each found translation.
 */
export function cromLookup(currentBranch, branches, fullname, addLink) {
  executeQuery(normaliseUrl(currentBranch.url + fullname), 0, function (response) {
    parseTranslations(response, currentBranch, branches, addLink);
  });
}

/**
 * Normalises a branch URL to one accepted by Crom.
 *
 * @param {String} url
 */
function normaliseUrl(url) {
  if (url.indexOf(".wikidot.com") === -1) {
    throw new Error("Crom requires wikidot.com branch URLs (" + url + ")");
  }
  return url.replace(/^https:/, "http:");
}

/**
 * Parses the response from the Crom API into a list of translations.
 *
 * @param {CromTranslations} response - The response from the Crom API.
 * @param {Branch} currentBranch - Configuration for the current branch.
 * @param {Object.<string, Branch>} branches - The branches configuration
 * for the current community. All passed branches will be searched for the
 * target page.
 * @param {addLinkCallback} addLink - A function that will be
 * called for each found translation.
 */
function parseTranslations(response, currentBranch, branches, addLink) {
  function url(page) {
    //console.log(`Mapped url: ${page.url}`);
    return page.url;
  }
  var original = null;
  var translations = [];

  // Extract translations of this page
  // Fuck I shouldn't comment this fucking line
  translations = translations.concat(response.translations.map(url));
  
  // Extract translations of this page's translation root
  if (response.translationOf) {
    original = response.translationOf.url;
    translations.push(original);
    /*
    translations = translations.concat(
      response.translationOf.translations.map(url)
    );
    */
   //console.log(`Translations list length: ${response.translationOf.translations.length}`);
   for(var i = 0; i < response.translationOf.translations.length; i++){
    //console.log(response.translationOf.translations[i].url);
    translations = translations.concat(response.translationOf.translations[i].url);
    //console.log(`Processed translation list: ${translations}`);
   }
  }
  //console.log(`Looking up for: ${JSON.stringify(branches)}`)
  //console.log(`Response's translation list:${JSON.stringify(response.translationOf)}`);
  //console.log(`Parsed translation url list:${translations}`);
  translations.forEach(function (translation) {
    // Do not add this translation if it is from the current branch
    //console.log(`This branch:${currentBranch.url}`);
    //console.log(`CUrrent translation url: ${translation}`);
    var fromCurrentBranch =
      translation.indexOf(normaliseUrl(currentBranch.url)) === 0;
    if (fromCurrentBranch) return;

    var targetBranchLang = Object.keys(branches).find(function (branchLang) {
      return translation.indexOf(normaliseUrl(branches[branchLang].url)) === 0;
    });
    if (!targetBranchLang) {
      // Crom may support unofficial/unconfigured branches
      console.warn("Interwiki: unknown branch " + translation);
      return;
    }

    addLink(
      translation,
      branches[targetBranchLang].name,
      targetBranchLang,
      original === translation
    );
  });
}

/**
 * Queries the Crom API for translations of the given page.
 *
 * @param {String} url - The HTTP Wikidot URL of the page for which to look
 * up translations.
 * @param {Number} endpointIndex - Retry index for Crom endpoints.
 * @param {Function} callback - Will be called with the response from Crom.
 */
function executeQuery(url, endpointIndex, callback) {
  var request = new XMLHttpRequest();
  //console.log(`Api List: ${apiList[endpointIndex]}, query index: ${endpointIndex}`)
  request.open("POST", apiList[endpointIndex], true);
  request.setRequestHeader("Content-Type", "application/json");
  request.addEventListener("readystatechange", function () {
    if (request.readyState === XMLHttpRequest.DONE) {
      try {
        if (request.status === 200) {
          var response = JSON.parse(request.responseText);
          if (response.errors && response.errors.length > 0) {
            //console.log(`Error, response is: ${response.text()}, ${request.responseURL}`);
            throw new Error(response.errors);
          }
          //console.log(`Response is: ${JSON.stringify(response.data.page)}`);
          callback(response.data.page);
        } else {
          //console.log(`Error in http status, response is: ${response.text()}, ${request.responseURL}`);
          throw new Error(request.status);
        }
      } catch (error) {
        // For some reason this code will overflow the maxmium length of apiList.
        //if (endpointIndex++ < apiList.length - 1) {
        // This code fixed this issue.
        if (endpointIndex++ < apiList.length - 1) {
          executeQuery(url, endpointIndex, callback);
        } else {
          //console.error(`Other exception error, response is: ${response.text()}, ${request.responseURL}`);
          console.error("Interwiki: lookup failed for " + url);
          console.error(error);
        }
      }
    }
  });
  request.send(JSON.stringify({ query: query, variables: { url: url } }));
}